/**
 * Copyright Aquera Inc 2023
 *
 * This source code is licensed under the BSD-3-Clause license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { css } from 'lit';

/**
 * ButtonFilter CSS
 */
export const styles = css`
  :host {
    -webkit-font-smoothing: var(--nile-webkit-font-smoothing, var(--ng-webkit-font-smoothing));
    -moz-osx-font-smoothing: var(--nile-moz-osx-font-smoothing, var(--ng-moz-osx-font-smoothing));
    text-rendering: var(--nile-text-rendering, var(--ng-text-rendering));
  }

  .inner__text {
    display: flex;
    gap: var(--nile-radius-base-standard);
	  align-items: flex-start;
  }

  .inner__text span {
    color: var(--nile-colors-dark-900);
    text-align: center;
    font-feature-settings: 'clig' off, 'liga' off;
    font-family: var(--nile-font-family-serif);
    font-size: var(--nile-font-size-base);
    font-style: normal;
    font-weight: var(--nile-font-weight-semi-bold);
    line-height: var(--nile-font-size-base); /* 100% */
    letter-spacing: 0.2px;
  }

  .inner__text nile-badge {
    color:var(--nile-colors-white-base);
  }
`;

export default [styles];
